import React, { FC, useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { T } from "services/lang/LanguageService";
import { DialIndicatorEditorProps } from "./DialIndicatorTypes";
import DialIndicatorDatasetsEditor from "./DialIndicatorDatasetsEditor";
import DialIndicatorZonesEditor from "./DialIndicatorZonesEditor";
import DialIndicatorTicksEditor from "./DialIndicatorTicksEditor";
import DialIndicatorOptionsEditor from "./DialIndicatorOptionsEditor";

const DialIndicatorEditor: FC<DialIndicatorEditorProps> = ({ config, onConfigChange }) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div className="dial-indicator-editor">
      <TabView activeIndex={tabIndex} onTabChange={e => setTabIndex(e.index)}>
        <TabPanel header={T("word.datasets")}>
          <DialIndicatorDatasetsEditor config={config} onConfigChange={onConfigChange} />
        </TabPanel>
        <TabPanel header={T("word.zones")}>
          <DialIndicatorZonesEditor config={config} onConfigChange={onConfigChange} />
        </TabPanel>
        <TabPanel header={T("word.ticks")}>
          <DialIndicatorTicksEditor config={config} onConfigChange={onConfigChange} />
        </TabPanel>
        <TabPanel header={T("word.options")}>
          <DialIndicatorOptionsEditor config={config} onConfigChange={onConfigChange} />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default DialIndicatorEditor;
